module.exports = "/shifts/components/filters/genericOptions-075086.html";